/**
 * auth.js
 */
export const SET_USER = 'SET_USER'
export const LOGOUT = 'LOGOUT'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_MYPROFILE = 'SET_MYPROFILE'
export const SET_COMPANIES = 'SET_COMPANIES'
export const SET_SITESUBSCRIPTION = 'SET_SITESUBSCRIPTION'
export const SET_USERPROFILES = 'SET_USERPROFILES'
export const UPDATE_USERPROFILE = 'UPDATE_USERPROFILE'
export const SET_PROFESSIONS = 'SET_PROFESSIONS'
export const SET_SKILLS = 'SET_SKILLS'
export const SET_COURSES = 'SET_COURSES'
export const UPDATE_COMPANY = 'UPDATE_COMPANY'